module.exports = __webpack_public_path__ + "static/media/planeacion_bco.584c0fec.svg";